module.exports = __webpack_public_path__ + "static/media/main-mobile.c91c578c.png";